import axios from 'axios';
import { VERIFY_EMAIL } from './constants';

export function postVerifyEmail(query) {
  return axios
    .post(
      VERIFY_EMAIL,
      { access_token: query.access_token },
      { withCredentials: true }
    )
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}
